export default __webpack_public_path__ + "static/media/mana2b.e933cd8b.svg";